import { useParams, useSearchParams } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { FaHeart, FaUserFriends, FaChild, FaExclamationTriangle, FaBus, FaMusic, FaCheckCircle, FaTimesCircle, FaRegCalendarAlt } from 'react-icons/fa';
import { useAxiosGet } from '../../../api/apiHook';
import '../WeddingPage.css';
import './GuestListPage.css';

function formatDateTime(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('es-ES', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export const GuestListPage = () => {
  const { domain } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const { data: card, error: cardError, loaded: cardLoaded } = useAxiosGet(
    'cards/findByDomain/',
    { domain },
  );

  const { data: attendances, error: listError, loaded: listLoaded } = useAxiosGet(
    'cards/getAttendances/',
    token ? { domain, token } : null,
  );

  const s = card?.wedding_settings || {};
  const vars = {
    '--wp-bg': s.backgroundColor || '#FAFAF8',
    '--wp-accent': s.buttonsColor || '#9baf8a',
    '--wp-text': s.descriptionTextColor || '#6A3B2E',
    '--wp-text-light': s.buttonsTextColor || '#FFFFFF',
    '--wp-border': s.buttonsBorderColor || s.backgroundColor || '#d8d8d6',
  };

  if (!token) {
    return (
      <div className="wp-page" style={vars}>
        <div className="wp-card guest-card">
          <Alert variant="danger">Este enlace no es válido.</Alert>
        </div>
      </div>
    );
  }

  if (!cardLoaded || !listLoaded) {
    return <div className="wp-page" style={vars}><div className="wp-card guest-card" /></div>;
  }

  if (cardError || listError) {
    return (
      <div className="wp-page" style={vars}>
        <div className="wp-card guest-card">
          <Alert variant="danger">No hemos podido cargar la lista de invitados.</Alert>
        </div>
      </div>
    );
  }

  const list = attendances || [];
  const attendingCount = list.filter((a) => a.will_attend).length;
  const totalAdults = list.filter((a) => a.will_attend).reduce((sum, a) => sum + (a.adult_count || 0), 0);
  const totalChildren = list.filter((a) => a.will_attend).reduce((sum, a) => sum + (a.children_count || 0), 0);

  return (
    <div className="wp-page" style={vars}>
      <div className="wp-card guest-card">
        <header className="wp-header">
          <p className="wp-subtitle">Lista de invitados</p>
          <h1 className="wp-couple guest-couple">
            {card?.bride_name || ''}<span className="wp-amp"> &amp; </span>{card?.groom_name || ''}
          </h1>
        </header>

        <hr className="wp-hr" />

        <div className="guest-summary">
          <div className="guest-summary-item">
            <span className="guest-summary-num">{attendingCount}</span>
            <span className="guest-summary-label">Confirmaciones</span>
          </div>
          <div className="guest-summary-item">
            <span className="guest-summary-num">{totalAdults}</span>
            <span className="guest-summary-label">Adultos</span>
          </div>
          <div className="guest-summary-item">
            <span className="guest-summary-num">{totalChildren}</span>
            <span className="guest-summary-label">Niños</span>
          </div>
        </div>

        <hr className="wp-hr" />

        {list.length === 0 && (
          <p className="wp-body">Todavía no hay confirmaciones registradas.</p>
        )}

        <div className="guest-list">
          {list.map((a) => (
            <div key={a.id} className={`guest-item ${a.will_attend ? 'guest-item--yes' : 'guest-item--no'}`}>
              <div className="guest-item-header">
                {a.will_attend
                  ? <FaCheckCircle className="guest-item-icon guest-item-icon--yes" />
                  : <FaTimesCircle className="guest-item-icon guest-item-icon--no" />}
                <span className="guest-item-name">{a.adult_names || 'Sin nombre'}</span>
              </div>
              <div className="guest-item-details">
                {a.will_attend && (
                  <>
                    <span className="guest-item-detail"><FaUserFriends /> {a.adult_count} adulto{a.adult_count === 1 ? '' : 's'}</span>
                    {a.children_count > 0 && (
                      <span className="guest-item-detail"><FaChild /> {a.children_count} niño{a.children_count === 1 ? '' : 's'}</span>
                    )}
                    {a.needs_bus && <span className="guest-item-detail"><FaBus /> Autobús</span>}
                    {a.allergies && <span className="guest-item-detail"><FaExclamationTriangle /> {a.allergies}</span>}
                    {a.song_request && <span className="guest-item-detail"><FaMusic /> {a.song_request}</span>}
                  </>
                )}
                {a.created_at && (
                  <span className="guest-item-detail guest-item-date"><FaRegCalendarAlt /> {formatDateTime(a.created_at)}</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <hr className="wp-hr" />
        <FaHeart className="wp-icon-heart guest-closing-heart" />
      </div>
    </div>
  );
};
